// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RGPO","newExpiryDate":"styles_newExpiryDate__16Fx0","footer":"styles_footer__3s2so"};